export const emptyAddress = {
  address: {
    area: '',
    city: '',
    cityAndStreet: '',
    cityDistrict: '',
    country: '',
    countryCode: '',
    entrance: '',
    fias: {
      areaId: '',
      cityDistrictId: '',
      cityId: '',
      flatId: '',
      houseId: '',
      regionId: '',
      settlementId: '',
      streetId: ''
    },
    flat: '',
    floor: '',
    house: '',
    intercom: '',
    latitude: 0,
    longitude: 0,
    rawLine: '',
    region: '',
    settlement: '',
    street: '',
    zipCode: ''
  },
  fullName: '',
  id: '',
  phone: ''
};
